"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EmployeeSearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return EmployeeSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const EmployeeSearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("employee"),
    format: _zod.z.literal("csv").optional(),
    // Different filters based on `searchFields()`
    name_re: _zod.z.string().optional(),
    name_eq: _zod.z.string().optional(),
    department_in: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    department_nin: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    department_eq: _utilsisomorphic.transformObjectId.optional(),
    department_ne: _utilsisomorphic.transformObjectId.optional(),
    email_eq: _zod.z.string().optional(),
    email_re: _zod.z.string().optional(),
    id_in: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    id_nin: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    id_eq: _utilsisomorphic.transformObjectId.optional(),
    id_ne: _utilsisomorphic.transformObjectId.optional(),
    department_hris_sync_exclusion: _utilsisomorphic.transformStringToBoolean.optional(),
    without_goals: _utilsisomorphic.transformStringToBoolean.optional()
});
